import { IRestModel, RestApi } from "@nkr/utils/rest-api";

export interface ISwabShipmentBatch extends IRestModel {
    id          : number,
    createdDate : string | null,
    createdBy   : string | null,
    shippedDate : string | null,
    shippedBy   : string | null,
    orderCount  : number
};

export const useSwabShipmentBatchApi = () => {
    const instance = new RestApi<ISwabShipmentBatch, ISwabShipmentBatch>(`${__API__}/hla/swab-shipment/batch`);
    return instance.makeHooks();
}